module.exports = __webpack_public_path__ + "static/media/index.af2a312d.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/fast-json-patch/index.mjs
// module id = 2816
// module chunks = 0